import React, { Component } from 'react';
import Axios from 'axios';
import Constant from '../Constant';
import '../../css/style.css';
import { getAccessToken } from '../../hooks/AccessToken';


class CountryManagement extends Component {
      
    state = {
        DataList: [],
        ERROR: true
    }

   
    //----------------------------------Integrate show Country API----------------------------------\\

    handleSubmit = () => {
        try {
            let { accessToken } = getAccessToken();
            let req = {
                'url': Constant.apiBasePath + 'location/country/getAll',
                'method': 'GET',
                'json': true,
                'headers': {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'token': accessToken
                }
            }
            Axios(req).then(response => {
                let data = response.data;
                if(data.status === Constant.statusSuccess) {
                    this.setState({ DataList: data.data, ERROR: false });
                }
                else{
                    alert(data.message);
                    return false;
                }
            }).catch(error => {
                console.log(error);
            })
        }
        catch(err) {
            console.log(err);
        }
    }

    //--------------------------------------------Reload component----------------------------------------------//    

    componentDidMount() {
        this.handleSubmit();
    }

    
    //-------------------------------------------End API-------------------------------------------------------\\     

    render() {
        const { DataList } = this.state;
        let i = 0;
        let bodyData = '';

        if(DataList.length > 0) {
            bodyData = DataList.map(el => {
                i++;
                const statusClass = el.status === 0 ? 'is-inactive' : 'is-active';
                const statusText = el.status === 0 ? 'Inactive' : 'Active';
                return (
                  <tr key={el._id || i}>
                    <td>{i}</td>
                    <td>{el.name}</td>
                    <td>{el.isoCode}</td>
                    <td className="country-status-col">
                      <span className={`contest-status-pill ${statusClass} country-status-pill`}>{statusText}</span>
                    </td>
                  </tr>
                )
            })
        }
        
        return (
            <div className="content-page contest-submissions-page contest-management-page location-management-page country-management-page event-consistent-page">
                <div className="content page-content-spaced">
                    <div className="event-management-header">
                        <div className="header-content">
                            <div className="header-title">
                                <h4 className="page-title-heading">Country Management</h4>
                                <p className="header-subtitle">Browse configured countries and their activation status.</p>
                            </div>
                        </div>
                    </div>

                    <div className="event-management-body">
                        <div className="card contest-like-card">
                                <div className="card-body">
                                    <div className="table-wrapper contest-submissions-table-responsive contest-like-table-responsive">
                                        <table className="table event-table contest-submissions-table contest-like-table location-management-table country-management-table">
                                            <thead>
                                                <tr>
                                                    <th className="location-sno-col">Serial number</th>
                                                    <th>Name</th>
                                                    <th>ISO Code</th>
                                                    <th className="country-status-col">Status</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                              {DataList.length > 0 ? (
                                                bodyData
                                              ) : (
                                                <tr>
                                                  <td colSpan="4" className="table-loading-cell">No countries found.</td>
                                                </tr>
                                              )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }    
        
}
export default CountryManagement;